var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import League from './League';
import { leagueSortFunc } from '../../../rendering-commons/Sorting';
var Sport = /** @class */ (function (_super) {
    __extends(Sport, _super);
    function Sport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sport.prototype.render = function () {
        var _a = this.props, sport = _a.sport, section = _a.section, expandedLeague = _a.expandedLeague, gridLocalization = _a.gridLocalization, leagues = _a.leagues, showSport = _a.showSport;
        var sportLeaguesIds = sport.get('leagues');
        var sportLeagues = sportLeaguesIds.map(function (m) { return leagues.get(m); });
        var renderLeagues = [];
        var props = {
            expandedLeague: expandedLeague,
            gridLocalization: gridLocalization,
            section: section,
            showSport: showSport,
            sportId: sport.get('id'),
            sportName: sport.get('name')
        };
        sportLeagues.sort(leagueSortFunc).map(function (league) {
            renderLeagues.push(_jsx(League, __assign({ id: league.get('id') }, props), league.get('id')));
        });
        return (_jsx("div", { children: renderLeagues }));
    };
    Sport.propTypes = {
        gridLocalization: PropTypes.object.isRequired,
        expandedLeague: PropTypes.bool,
        showSport: PropTypes.bool,
        section: PropTypes.string.isRequired,
        sport: PropTypes.object.isRequired
    };
    return Sport;
}(React.Component));
var mapStateToProps = function (state, props) { return ({
    leagues: state.application.getIn([props.section, 'leagues'])
}); };
Sport = connect(mapStateToProps)(Sport);
export default Sport;



// WEBPACK FOOTER //
// ./src/components/grid/live/Sport.jsx